import React from "react";
import { css } from "glamor";
import { Message } from "semantic-ui-react";
import { spacing } from "../library/theme";

const messageContainer = css({
  marginTop: spacing.m,
  marginBottom: spacing.m,
});

export default function EquivalentLessonWarning({ shouldShowWarning, courseName }) {
  if (!shouldShowWarning || !courseName) {
    return null;
  }

  return (
    <div className={messageContainer}>
      <Message info>
        <Message.Content>
          <Message.Header>
            Aula marcada como assistida
          </Message.Header>
          <p>
            Esta aula está marcada como assistida porque você já assistiu uma
            aula equivalente no curso <strong>{courseName}</strong>.
          </p>
        </Message.Content>
      </Message>
    </div>
  );
}

